var Products_Slider = {

	isMoving:false,
	mouseX:0,
	mouseY:0,
	timeoutResize:0,

	init:function(){
		$(window).resize(function(){
			Products_Slider.resize();	
		});

		Products_Slider.resize();


		if(Config.isTouchDevice()){
			$(".rollover-product-container").addClass("mobile");
		}

		$(window).mousemove(function(event){            
			Products_Slider.mouseX = event.pageX;
			Products_Slider.mouseY = event.pageY;
		});

		$(".products-slider .tease-product").find(".tease--img-container").mouseenter(function(){

			$(".rollover-product-container").addClass("visible");

			/*$(this).find("img").css({width:$(this).find("img").attr("hover_w"), height:$(this).find("img").attr("hover_h")});*/
			var attr = $(this).parent().attr('outofstock');
			/*
			if (typeof attr !== 'undefined' && attr !== false) {
				$(".rollover-product-container").addClass("outofstock");
			}else{
				$(".rollover-product-container").removeClass("outofstock");
			}
			*/
			Products_Slider.isMoving = true;
			Products_Slider.moveRollover();
		}).mouseleave(function(){
			Products_Slider.isMoving = false;

			/*$(this).find("img").css({width:$(this).find("img").attr("out_w"), height:$(this).find("img").attr("out_h")});*/
			$(".rollover-product-container").removeClass("visible");
		});
	},
	moveRollover:function(){

		$(".rollover-product-container").css({left:Products_Slider.mouseX, top:Products_Slider.mouseY});

		if(Products_Slider.isMoving == true){
			setTimeout(function(){
				Products_Slider.moveRollover();
			}, 40);
		}
	},
	resize:function(){
		var _carousel = $(".products-slider .products--list");
				
		clearTimeout(Products_Slider.timeoutResize);
		Products_Slider.timeoutResize = setTimeout(function(){
			$(".products-slider .arrow-container").css({height:$(".products-slider .tease--img-container").outerHeight()})
		}, 40);

		if (_carousel.hasClass('slick-initialized')) {
			_carousel.slick('unslick');
		}

		//var _slides_to_show = parseInt($("[slider-3-columns]").css("padding-top"));

		var _slides_to_show = 1;
		var els = document.querySelectorAll(".products-slider");

		Array.prototype.forEach.call(els, function(el) {

			_slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));

		});



		_carousel.slick({
			arrows:true, 
			dots:false,
			infinite: true,
			variableWidth:true,
			slidesToShow: _slides_to_show,
			focusOnSelect: false,
			touchThreshold:500,
			prevArrow:_carousel.parent().find(".arrow-container.prev .arrow"),
			nextArrow:_carousel.parent().find(".arrow-container.next .arrow"),
		});	
	}
}

$(window).load(function(){
	if($(".products-slider").length){
		Products_Slider.init();	
	}		
});